export default Object.freeze({
  Price: 1,
  Detail: 2,
});
